/* Custom: Variant image filter by filename - El Capitano
 *
 * DROPDOWN MAGIC NUMBERS (nicht anfassen ohne Test!):
 * --dropdown-top: rect.bottom - 30  → vertikaler Abstand unter dem Header
 * submenuWidth: 225                  → feste Breite für Zentrierung
 * Beide Werte in der positionDropdowns() Funktion unten.
 *
 * BILDER-NAMENSSCHEMA (wichtig für neue Produkte!):
 * [farbe]_[produkt]_[ansicht]_[person].webp
 * Einwort-Farben: black, navy, white, red, azalea, sapphire → normaler Unterstrich
 * Mehrwort-Farben: military-green, sport-grey, punch-pink → Bindestrich innerhalb der Farbe
 * Beispiel: punch-pink_dilligaffu_front_mann.webp
 */

document.addEventListener('variant:update', function (e) {
  if (!e.detail || !e.detail.resource) return;

  var mediaSrc = '';
  try {
    mediaSrc = e.detail.resource.featured_media.preview_image.src.toLowerCase();
  } catch(err) { return; }

  var filename = decodeURIComponent(mediaSrc.split('/').pop().split('?')[0]);

  // Farbe = alles vor dem ersten Unterstrich
  var colorMatch = filename.split('_')[0];

  if (!colorMatch) return;

  document.querySelectorAll('.product-media-container').forEach(function (item) {
    var img = item.querySelector('img');
    if (!img) return;
    var src = decodeURIComponent((img.src || img.getAttribute('src') || '').toLowerCase());
    var itemFilename = src.split('/').pop().split('?')[0];
    item.style.display = itemFilename.startsWith(colorMatch) ? '' : 'none';
  });
});

// Größentabelle Modal
document.addEventListener('DOMContentLoaded', function() {
  var btn = document.getElementById('groessentabelle-btn');
  if (!btn) return;
  var modal = document.getElementById('groessentabelle-modal');
  var close = document.getElementById('groessentabelle-close');
  btn.addEventListener('click', function() { modal.style.display = 'flex'; });
  close.addEventListener('click', function() { modal.style.display = 'none'; });
  modal.addEventListener('click', function(e) { if (e.target === modal) modal.style.display = 'none'; });
});

// Dropdown Fix
var style = document.createElement('style');
style.textContent = `
  .menu-list__list-item:where(:not([slot='overflow'])) > .menu-list__submenu {
    position: fixed !important;
    width: auto !important;
    min-width: 160px !important;
    clip-path: none !important;
    background: transparent !important;
    box-shadow: none !important;
    z-index: 9999 !important;
    padding: 4px 0 !important;
    left: var(--dropdown-left, 0px) !important;
    top: var(--dropdown-top, 0px) !important;
  }
  .menu-list__submenu-inner {
    padding: 8px 0 !important;
    max-height: none !important;
    overflow: visible !important;
    background: transparent !important;
  }
  .mega-menu__grid {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }
  .mega-menu__link {
    padding: 6px 20px !important;
    white-space: nowrap !important;
  }
  .overflow-menu::after {
    display: none !important;
  }
  header-menu, .header__column, .header__columns, .header__row {
    overflow: visible !important;
  }
`;
document.head.appendChild(style);

// Position per JS
function positionDropdowns() {
  document.querySelectorAll('.menu-list__list-item:not([slot="overflow"])').forEach(function(item) {
    item.addEventListener('pointerenter', function() {
      var submenu = item.querySelector('.menu-list__submenu');
      if (!submenu) return;
      var rect = item.getBoundingClientRect();
      var submenuWidth = 225;
      var left = rect.left + rect.width / 2 - submenuWidth / 2;
      left = Math.max(8, Math.min(left, window.innerWidth - submenuWidth - 8));
      document.documentElement.style.setProperty('--dropdown-left', left + 'px');
      document.documentElement.style.setProperty('--dropdown-top', (rect.bottom - 30) + 'px');
    });
  });
}

setTimeout(positionDropdowns, 500);
setTimeout(positionDropdowns, 1500);

// Produkte auf Collection-Seite zufällig anordnen 16052026 1535
document.addEventListener('DOMContentLoaded', function () {
  var grid = document.querySelector('ul.grid, .collection-grid, .product-grid');
  if (!grid) return;
  var items = Array.from(grid.children);
  for (var i = items.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    grid.appendChild(items[j]);
    var temp = items[i];
    items[i] = items[j];
    items[j] = temp;
  }
});
